// Redux sagas for KPI Dashboard

import { call, put, takeLatest, all } from 'redux-saga/effects';
import apiRequest from '@libs/apiRequest';
import {
    FETCH_USER_KPI_PERIODS_REQUEST,
    FETCH_USER_KPI_PERIODS_SUCCESS,
    FETCH_USER_KPI_PERIODS_FAILURE,
    FETCH_USER_KPI_DETAILS_REQUEST,
    FETCH_USER_KPI_DETAILS_SUCCESS,
    FETCH_USER_KPI_DETAILS_FAILURE
    ,
    FETCH_EMPLOYEE_PREVIEW_REQUEST,
    FETCH_EMPLOYEE_PREVIEW_SUCCESS,
    FETCH_EMPLOYEE_PREVIEW_FAILURE
} from './redux.actions';
import { API_ENDPOINTS, getErrorMessage } from './common';
import { extractErrorDetails } from '@libs/errorUtils';

// Saga for fetching user's KPI periods
function* fetchUserKpiPeriodsSaga(action) {
    try {
        const { userId } = action.payload || {};
        let url;
        if (userId) {
            url = `/kpi/period/get/user/${userId}/kpi-periods`;
        } else {
            url = API_ENDPOINTS.GET_MY_PERIODS;
        }
        const response = yield call(apiRequest, {
            url,
            method: 'GET'
        });
        yield put({
            type: FETCH_USER_KPI_PERIODS_SUCCESS,
            payload: response.data?.data || []
        });
    } catch (error) {
        const errorMessage = getErrorMessage(error, 'Failed to fetch KPI periods');
        yield put({
            type: FETCH_USER_KPI_PERIODS_FAILURE,
            payload: { message: errorMessage }
        });
    }
}

// Saga for fetching detailed KPI data for a specific period
function* fetchUserKpiDetailsSaga(action) {
    try {
        const { periodId, userId } = action.payload;
        let url;
        if (userId) {
            url = `/kpi/user-kpi/get/user/${userId}/period/${periodId}`;
        } else {
            url = `${API_ENDPOINTS.GET_MY_KPI_BY_PERIOD}/${periodId}`;
        }
        const response = yield call(apiRequest, {
            url,
            method: 'GET'
        });
        yield put({
            type: FETCH_USER_KPI_DETAILS_SUCCESS,
            payload: response.data || {}
        });
    } catch (error) {
        const errorMessage = getErrorMessage(error, 'Failed to fetch KPI details');
        yield put({
            type: FETCH_USER_KPI_DETAILS_FAILURE,
            payload: { message: errorMessage }
        });
    }
}

// Root saga for dashboard
export default function* dashboardSaga() {
    yield all([
        takeLatest(FETCH_USER_KPI_PERIODS_REQUEST, fetchUserKpiPeriodsSaga),
        takeLatest(FETCH_USER_KPI_DETAILS_REQUEST, fetchUserKpiDetailsSaga)
        ,
        takeLatest(FETCH_EMPLOYEE_PREVIEW_REQUEST, fetchEmployeePreviewSaga)
    ]);
}

// Saga for fetching employee preview data
function* fetchEmployeePreviewSaga() {
    try {
        const response = yield call(apiRequest, {
            url: API_ENDPOINTS.GET_EMPLOYEE_PREVIEW,
            method: 'GET'
        });
        yield put({
            type: FETCH_EMPLOYEE_PREVIEW_SUCCESS,
            payload: response.data?.data || []
        });
    } catch (error) {
        const errorMessage = getErrorMessage(error, 'Failed to fetch employee preview');
        yield put({
            type: FETCH_EMPLOYEE_PREVIEW_FAILURE,
            payload: { message: errorMessage }
        });
    }
}